




















































































































































































































































































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { defaultSystemCode, SystemCode } from '@/api'
import {
  BookMaxlength,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'

export interface AutoOrderEditInputsItem {
  orderAutoId: number | null
  orderBranchCode: SystemCode
  orderNumber: {
    input: string
    errorMessage: string
  }
  traderCode: {
    input: string
    display: string
    errorMessage: string
  }
  acceptType: {
    input: string
    display: string
    errorMessage: string
  }
  buyDepartmentCode: {
    input: string
    display: string
    errorMessage: string
  }
  donatedNumber: {
    input: string
    errorMessage: string
  }
  donorCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetYear: {
    input: string
    errorMessage: string
  }
  budgetBranchCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetDepartmentCode: {
    input: string
    display: string
    errorMessage: string
  }
  budgetItem: {
    input: string
    display: string
    errorMessage: string
  }
  equipType: {
    input: string
    display: string
    errorMessage: string
  }
  collectionType: {
    input: string
    display: string
    errorMessage: string
  }
  shelfType: {
    input: string
    display: string
    errorMessage: string
  }
  handlingType: {
    input: string
    display: string
    errorMessage: string
  }
  storeType: {
    input: string
    display: string
    errorMessage: string
  }
  storingLimitCode: {
    input: string
    display: string
    errorMessage: string
  }
  mark: {
    input: string
    errorMessage: string
  }
  ndc: {
    input: string
    errorMessage: string
  }
  book: {
    input: string
    errorMessage: string
  }
  sub: {
    input: string
    errorMessage: string
  }
  revision: number | null
}

export const defaultAutoOrderEditInputsItem = (): AutoOrderEditInputsItem => ({
  orderAutoId: null,
  orderBranchCode: defaultSystemCode(),
  orderNumber: {
    input: '',
    errorMessage: ''
  },
  traderCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  acceptType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  buyDepartmentCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  donatedNumber: {
    input: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetYear: {
    input: '',
    errorMessage: ''
  },
  budgetBranchCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetDepartmentCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  budgetItem: {
    input: '',
    display: '',
    errorMessage: ''
  },
  equipType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  shelfType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  handlingType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  storeType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  storingLimitCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  mark: {
    input: '',
    errorMessage: ''
  },
  ndc: {
    input: '',
    errorMessage: ''
  },
  book: {
    input: '',
    errorMessage: ''
  },
  sub: {
    input: '',
    errorMessage: ''
  },
  revision: null
})

@Component({
  components: {
    InputCodeTrader,
    InputCodeDonor,
    InputCode
  }
})
export default class AutoOrderEditInputs extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  item!: AutoOrderEditInputsItem

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
